/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'avi-forms';
const componentName = 'avi-enum-dropdown';
const prefix = `${moduleName}.${componentName}`;

export const defaultPlaceholderText = `${prefix}.defaultPlaceholderText`;

export const ENGLISH = {
    [defaultPlaceholderText]: 'Select',
};
